import { useState, useRef } from 'react';

/**
 * Hook for managing the icon picker
 */
export function useIconPicker({ taskId, onIconChange }) {
  const [showPicker, setShowPicker] = useState(false);
  const [pickerPosition, setPickerPosition] = useState(null);
  const buttonRef = useRef(null);

  const openPicker = (e, customPosition) => {
    e?.stopPropagation();
    
    const viewportHeight = window.innerHeight;
    const viewportWidth = window.innerWidth;
    const menuHeight = 420;
    const menuWidth = 320;
    
    // Use custom position if provided (e.g., from drag handle menu)
    if (customPosition) {
      let top = customPosition.y;
      if (top + menuHeight > viewportHeight) {
        top = viewportHeight - menuHeight - 10;
      }
      
      let left = customPosition.x;
      if (left + menuWidth > viewportWidth) {
        left = viewportWidth - menuWidth - 10;
      }
      
      setPickerPosition({ x: left, y: top });
    } else if (buttonRef.current) {
      // Use button position (when clicking icon button)
      const rect = buttonRef.current.getBoundingClientRect();
      
      let top = rect.bottom + 4;
      if (top + menuHeight > viewportHeight) {
        top = rect.top - menuHeight - 4;
      }
      
      let left = rect.left;
      if (left + menuWidth > viewportWidth) {
        left = viewportWidth - menuWidth - 10;
      }
      
      setPickerPosition({ x: left, y: top });
    } else {
      // Fallback: center of viewport
      setPickerPosition({ 
        x: (viewportWidth - menuWidth) / 2, 
        y: (viewportHeight - menuHeight) / 2 
      });
    }
    setShowPicker(true);
  };

  const closePicker = () => {
    setShowPicker(false);
    setPickerPosition(null);
  };

  const changeIcon = (newIcon) => {
    onIconChange?.(taskId, newIcon);
  };

  return {
    buttonRef,
    showPicker,
    pickerPosition,
    openPicker,
    closePicker,
    changeIcon,
  };
}

export default useIconPicker;

